import type { BeneficiaryListItemPayload } from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiariesFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries only what the directory resolves a name for — first name before last name, the order a
 * professional expects when reading a running list, not the administrative order used to identify a
 * care record (`BeneficiaryListItemView.fullName`).
 */
class BeneficiaryDirectoryEntryView {
	readonly id: number;
	readonly fullName: string;

	constructor(payload: BeneficiaryListItemPayload) {
		this.id = payload.id;
		this.fullName = `${payload.firstName} ${payload.lastName}`;

		Object.freeze(this);
	}
}

export default BeneficiaryDirectoryEntryView;
